import { SingleSelectQuestion } from "./single-select";

export default SingleSelectQuestion;
